import { Buffer } from 'buffer';
import Vue from 'vue'
import * as zlib from 'react-zlib-js';
import { fxViewMixins } from '@/plugins/fxView'
import store from './store'
import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";

// const 
// import Vue from 'vue'
const mixins = [fxViewMixins];

export default class WebSocketService {
  constructor() {
    this.storeData= store
    this.socket = null;
    this.url = "wss://webfeed.fxview.com/";
    this.onOpenCallback = null;
    this.onMessageCallback = null;
    this.onCloseCallback = null;
    this.onErrorCallback = null;
    this.isinsData = {};
    this.subscriptionsToRemove = {};
    this.connecting = false;
    this.socketReady = false;
  }
  
  connect(defaultList) {
    let isinsList = defaultList


    if (this.socketReady) {
      this.sendWatchlist(isinsList);
      return;
    }
    if (!this.connecting) {
      this.connecting = true;
      this.socket = new WebSocket(this.url);

      this.socket.onopen = () => {
        console.log('onOPEN')
        this.socketReady = true;
        this.connecting = true;
        // console.log('defaultList',isinsList)
        this.socket.send(isinsList)
      };

      this.socket.onmessage = (message) => {
        const responseBuffer = Buffer.from(message.data, 'base64');
        zlib.unzip(responseBuffer, (err, buffer) => {
          if (!err) {
            try {
              const jsonMsg = JSON.parse(buffer.toString());
              if (Object.keys(jsonMsg).length) {
                if (!('orderbook' in jsonMsg) && !('message' in jsonMsg) && !('isins' in jsonMsg) && !('price_alert' in jsonMsg)) {
                  let Data = {}
                  for(const key in jsonMsg){
                    let newKey = key.replace(/\.HKT|^[^ ]+ /g, '')
                    Data[newKey]  = jsonMsg[key]
                    Data[newKey]['SPREAD'] = Math.abs(jsonMsg[key].B - jsonMsg[key].A)
                    if(this.isinsData[newKey]){
                      Data[newKey].buy_increase_staus = Data[newKey].B > this.isinsData[newKey].B
                      Data[newKey].sell_increase_staus = Data[newKey].A > this.isinsData[newKey].A
                    }
                  }
                  this.isinsData = { ...this.isinsData, ...Data };
                  this.storeData.commit(Const.SET_PRICEFEED_DATA, this.isinsData);
                }
              }
            } catch (parseError) {
              console.error('JSON parse error', parseError);
            }
          } else {
            console.error('Unzipping error', err);
          }
        });
      };

      this.socket.onclose = (event) => {
        this.socketReady = false;
      };

      this.socket.onerror = (error) => {
        // console.log('WebSocket error', error);
      };
    }
  }


  sendWatchlist(isinsList) {
    let message = JSON.stringify({"watchlist":isinsList,"auth":""});
    
    setTimeout(() => {
      if(this.socketReady){
        this.socket.send(message)
      }
    },2000);
  }
}



// WEBPACK FOOTER //
// ./src/store/websocket.js